import { type CoreLayoutProps, Logout } from 'react-admin'
import {
  AppBar as RaAppBar,
  Box,
  Toolbar,
  Typography,
  styled
} from '@mui/material'
import React from 'react'
import { isNil } from 'lodash/fp'

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  zIndex: 1,
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  position: 'relative'
}))
const RootWithoutTitle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  zIndex: 1,
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  position: 'relative'
}))
const AppFrame = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'auto'
}))
const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  //   padding: theme.spacing(10),
  marginTop: '4em',
  marginLeft: '0'
}))
const ContentWithoutTitle = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  //   padding: theme.spacing(10),
  marginTop: '1em',
  marginLeft: '0'
}))
const AppBar: React.FC<{
  title: string
}> = ({ title, ...props }) => (
  <RaAppBar {...props} title={title}>
    <Toolbar>
      <Typography variant="h6" id="react-admin-title" />
      <Box flex="1" />
      {!isNil(process.env['REACT_APP_VERSION']) && (
        <Typography
          variant="subtitle1"
          sx={{ marginTop: '0em', marginLeft: '1em' }}>
          {`${process.env['REACT_APP_VERSION']}`}
        </Typography>
      )}
      <Logout />
    </Toolbar>
  </RaAppBar>
)
export const Layout: React.FC<CoreLayoutProps> = ({ children, title }) => (
  <Root>
    <AppFrame>
      <AppBar title={title as string} />
      <Content>{children}</Content>
    </AppFrame>
  </Root>
)
export const LayoutWithoutTitle: React.FC<CoreLayoutProps> = ({ children }) => (
  <RootWithoutTitle>
    <AppFrame>
      <ContentWithoutTitle>{children}</ContentWithoutTitle>
    </AppFrame>
  </RootWithoutTitle>
)
